import React from "react";

const baseurl = "rizzapi.vercel.app/";

const Rate = () => {
  return (
    <section id="rate">
      <div className="line"></div>
      <div className="dbline"></div>
      <div className="subheading">
        💬 Rate a Pickup Line (Give It Some Love!)
      </div>
      method : <span className="method">POST</span>
      <div className="dbline"></div>
      Endpoint: <span className="method">{baseurl}rating/:id</span>
      <div className="dbline"></div>
      Description:
      <br /> Did a pickup line make you smile or cringe? Give it your rating on
      a scale from 1 to 10, with 10 being the highest score! Spread the love! ❤️
      <div className="dbline"></div>
      Request Body:
      <br />
      <div className="idea">
        - `rating` (number, required) - Your rating for the pickup line.
      </div>
      <div className="dbline"></div>
      Responses:
      <br />
      <ul className="disc">
        <li>
          <span className="method">200 OK</span> <br />{" "}
          <div className="idea">
            - You successfully rated the pickup line! 🌟 The line's popularity
            is soaring, and you'll get the updated pickup line in return. Keep
            the good vibes rolling! 😄
          </div>
        </li>
        <li>
          <span className="method">400 Bad Request</span>
          <br />
          <div className="idea">
            - Oops, seems like you've entered an out-of-range rating (we don't
            do negatives or hundreds!). Please rate within the 1 to 10 range. 🚫
          </div>
        </li>
        <li>
          <span className="method">404 Not Found</span> <br />
          <div className="idea">
            - Oops, the pickup line with that specific ID seems to be MIA. 🕵️‍♂️
          </div>
        </li>
        <li>
          <span className="method">500 Internal Server Error</span>
          <br />
          <div className="idea">
            - Uh-oh! Our server is taking a break. Please try again later! 🛠️
          </div>
        </li>
      </ul>
      <div className="dbline"></div>
      <div className="line"></div>
    </section>
  );
};

export default Rate;
